export default __webpack_public_path__ + "static/media/01_reeach-maker_tour_confetti.2b70ad4e.mp4";